import Vue from 'vue'
import draggable from 'vuedraggable'

$(() => {
  if (!$('.js-faq-input').length) {
    return
  }

  const setupComponent = (id) => {
    new Vue({
      el: id,
      components: {
        'draggable': draggable,
      },
      data: {
        rules: $(id).data('rules'), // Validルール
        values: $(id).data('values'),
        form: "",
        errors: [], // Validエラーメッセージ
      },
      mounted() {
        this.setValueToForm()
        $('.js-form-validation .submit').on('click', (e) => {
          this.validForm()
        })
      },
      methods: {
        validForm() {
          if (!this.rules || this.rules.length == 0) {
            // 未定義はリターン
            return
          }
          this.errors = []
          if (this.values.length == 0) {
            this.errors.push("少なくとも1件以上入力してください")
          }

          $(id).find('input').trigger('change')
        },
        setValueToForm() {
          this.form = JSON.stringify(this.values)
        },
        onChangeValues() {
          this.setValueToForm()
          this.validForm()
        },
        onAddValue() {
          this.values.push({
            "q": "",
            "a": ""
          })
          this.onChangeValues()
        },
        onDeleteValue(index) {
          this.values.splice(index, 1)
          this.onChangeValues()
        },
        onMove() {
          this.onChangeValues()
        },
      },
    })
  }

  $('.js-faq-input').each((i, element) => {
    const id = $(element).attr('id')
    setupComponent('#' + id)
  })
})
